import React from 'react';
import Card from "../../shared/components/UIElements/Card";
import PatientViewItem from './PatientViewItem';
import Button from "../../shared/components/FormElements/Button";
import './PatientViewList.css';

const PatientViewList = (props) => {
  if (!props.items || props.items.length === 0) {
    return (
      <div className="place-list centre">
        <Card>
          <h2>No patient found</h2>
          <Button to='/'>GO BACK</Button>
        </Card>
      </div>
    );
  }

  return (
    <ul className="place-list">
      {props.items.map((item) => (
        <PatientViewItem
          key={item.id}
          id={item.id}
          name={item.name}
          history={item.history}
        />
      ))}
    </ul>
  );
};

export default PatientViewList;